import { BumpOut, DrawingEdge } from './../../../../models/drawing-shape.model';

import { roundToArrowLengthGranularity } from '~/core/helpers';

export const createBumpOutWithHalfEdgeLength = (
  edge: DrawingEdge,
  edgeLength: number,
  bumpOutLength: number
): number => {
  let bumpOutLengthToUse = bumpOutLength;

  // if the bumpOut length is longer than the edge length, create a bumpOut that is half the edge length
  if (edgeLength < bumpOutLength + 2) {
    bumpOutLengthToUse = roundToArrowLengthGranularity(edgeLength / 2);
    (edge.bumpOut as BumpOut).clockwiseRemainderLength =
      roundToArrowLengthGranularity((edgeLength - bumpOutLengthToUse) / 2);
    (edge.bumpOut as BumpOut).counterClockwiseRemainderLength =
      roundToArrowLengthGranularity((edgeLength - bumpOutLengthToUse) / 2);

    return bumpOutLengthToUse;
  } else if (
    // if the edge length is different from the sum of the component lengths, distribute the + or - mismatch to the remaining edges
    edgeLength !==
    bumpOutLength +
      (edge.bumpOut as BumpOut).clockwiseRemainderLength +
      (edge.bumpOut as BumpOut).counterClockwiseRemainderLength
  ) {
    const misMatch =
      bumpOutLength +
      (edge.bumpOut as BumpOut).clockwiseRemainderLength +
      (edge.bumpOut as BumpOut).counterClockwiseRemainderLength -
      edgeLength;

    (edge.bumpOut as BumpOut).clockwiseRemainderLength -= misMatch / 2;
    (edge.bumpOut as BumpOut).counterClockwiseRemainderLength -= misMatch / 2;
  }

  return bumpOutLength;
};
